<template>
  <v-container fluid>
    <v-col cols="12">
      <v-row align="center" justify="center">
        <v-card v-if="error" class="elevation-0">
          <app-alert-error @dismissed="onDismiss" :text="error.message"></app-alert-error>
        </v-card>
      </v-row>
      <v-row align="center" justify="center">
        <v-form class="pa-4 ma-4" ref="form" v-model="valid" @submit.prevent="onSubmit">
          <v-text-field v-model="email" :rules="fieldRules('E-mail')" type="email" name="email" label="E-mail" outlined dense></v-text-field>
          <v-text-field v-model="password" :rules="fieldRules('Password')" type="password" name="password" label="Password" outlined dense></v-text-field>
          <v-btn class="farmer_green white--text" @click="onSubmit" block>Submit</v-btn>
        </v-form>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { store } from '@/store'
export default {
  data() {
    return {
      email: '',
      password: '',
      valid: true
    }
  },
  computed: {
    ...mapGetters(['error']),
    fieldRules() {
      return name => [v => !!v || `${name} is required`]
    }
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        const admin = {
          email: this.email,
          password: this.password
        }
        store.dispatch('loginSpa', admin)
      }
    }
  }
}
</script>
